import { createAction } from 'redux-actions';

export const leadUserJoinRequest = createAction('LEAD_USER_JOIN_REQUEST');
export const leadUserJoinSuccess = createAction('LEAD_USER_JOIN_SUCCESS');
export const leadUserJoinFail = createAction('LEAD_USER_JOIN_FAIL');
